/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalCommonCustomAttributeDecimalTypeValueFromJSON, InternalCommonCustomAttributeDecimalTypeValueToJSON, } from './InternalCommonCustomAttributeDecimalTypeValue';
import { InternalCommonSharingVisibilityFromJSON, InternalCommonSharingVisibilityToJSON, } from './InternalCommonSharingVisibility';
/**
 * @export
 */
export const InternalCommonCustomAttributeDecimalTypeTypeEnum = {
    Decimal: 'decimal'
};
/**
 * Check if a given object implements the InternalCommonCustomAttributeDecimalType interface.
 */
export function instanceOfInternalCommonCustomAttributeDecimalType(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('visibility' in value) || value['visibility'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('value' in value) || value['value'] === undefined)
        return false;
    return true;
}
export function InternalCommonCustomAttributeDecimalTypeFromJSON(json) {
    return InternalCommonCustomAttributeDecimalTypeFromJSONTyped(json, false);
}
export function InternalCommonCustomAttributeDecimalTypeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'visibility': InternalCommonSharingVisibilityFromJSON(json['visibility']),
        'type': json['type'],
        'value': InternalCommonCustomAttributeDecimalTypeValueFromJSON(json['value']),
    };
}
export function InternalCommonCustomAttributeDecimalTypeToJSON(json) {
    return InternalCommonCustomAttributeDecimalTypeToJSONTyped(json, false);
}
export function InternalCommonCustomAttributeDecimalTypeToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'visibility': InternalCommonSharingVisibilityToJSON(value['visibility']),
        'type': value['type'],
        'value': InternalCommonCustomAttributeDecimalTypeValueToJSON(value['value']),
    };
}
